import React, { useEffect } from 'react';
import styled from '@grebban/style-system-react';
import { useHeaderNavigationContext } from '@fogia/core-web/contexts/HeaderNavigationContext';
import useAppSelector from '@fogia/core-web/hooks/useAppSelector';
import { allowScroll, preventScroll } from '@fogia/core-web/utils/scroll';
import { HeaderComponent } from './HeaderComponent';
import CrawlerLinks from './navigation/CrawlerLinks';
import { type MainMenuItem, type UtilityMenuItem } from './types';

const StyledHeader = styled('header')`
    position: fixed;
    width: 100%;
    /* HeaderContext sets --header-top-position (0 or -height) so header slides up on scroll down, back on scroll up. */
    top: var(--header-top-position, 0);
    z-index: 99;
    transition: top 0.25s ease-out;
`;

export const Header = () => {
    const { headerNavigationState } = useHeaderNavigationContext();

    // @TODO: is this needed?
    const mainMenu = useAppSelector((state) => state.application?.header?.data?.headerNavigation?.mainMenu) as
        | MainMenuItem[]
        | undefined;
    const utilityMenu = useAppSelector((state) => state.application?.header?.data?.headerNavigation?.utilityMenu) as
        | UtilityMenuItem[]
        | undefined;
    const crawlerMenuItems = [...(mainMenu ?? []), ...(utilityMenu ?? [])] as React.ComponentProps<
        typeof CrawlerLinks
    >['menuItems'];

    useEffect(() => {
        if (
            headerNavigationState.mobileMenuActive ||
            headerNavigationState.desktopMenuActive ||
            headerNavigationState.searchActive ||
            headerNavigationState.storeFinderActive
        ) {
            preventScroll();
        } else {
            allowScroll();
        }
    }, [
        headerNavigationState.desktopMenuActive,
        headerNavigationState.mobileMenuActive,
        headerNavigationState.searchActive,
        headerNavigationState.storeFinderActive,
    ]);

    return (
        <StyledHeader>
            <div style={{ display: 'none' }} aria-hidden>
                <CrawlerLinks menuItems={crawlerMenuItems} />
            </div>
            <HeaderComponent />
        </StyledHeader>
    );
};
